@import "../../../../themes/site/default/assets/responsive_helpers.scss";

.section--image-gallery {
  .splide {
    margin: 0 auto;
  }

  .splide.is-active .splide__list {
    align-items: center;
  }

  .splide__track {
    margin-top: 20px;
  }

  .main-slider {
    .splide {
      &__slide {
        opacity: 0.3;
      }

      &__slide.is-active {
        opacity: 1;
      }

      &__slide__container {
        overflow-y: hidden;
      }

      &__slide__text-container {
        padding: 5px 0;
        font-size: 18px;
      }
    }

  }


  .thumbnail-slider {
    @include below-tablet {
      display: none !important;
    }
  }
}
